import { Component, OnInit } from '@angular/core';

import { UtilService } from "../../../shared/services/util.service";
import {OrdemServico} from "../shared/ordem-servico.model";
import {ordensServicoModuleName, OrdemServicoStatus} from "../shared/data.service";
import {OrdemServicoApiService} from "../shared/ordem-servico-api.service";
import {OrdemServicoService} from "../shared/ordem-servico.service";
import {OrdemServicoNavigationService} from "../shared/ordem-servico-navigation.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {frotasQuery} from "../../../bens/frotas/shared/data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";
import {ManutencaoProgramadaService} from "../../manutencao-programada/shared/manutencao-programada.service";

@Component({
    template: require('./ordem-servico-list.component.html'),
    styles: [require('./ordem-servico-list.component.css')]
})
export class OrdemServicoListComponent implements OnInit {
    list: OrdemServico[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    ordemServicosModuleName: any = ordensServicoModuleName;
    query: any = {};

    showFrotaLink: boolean = false;
    frotaDetailHistory: any = {};
    frotaRoute: string;
    frotasModule: any = {};

    statusList: any[] = [];
    frotaQuery: any;
    frotaSelectId: string = "frota";

    constructor(
        private _ordemServicosApiService: OrdemServicoApiService,
        private _ordemServicoService: OrdemServicoService,
        private _ordemServicoNavigationService: OrdemServicoNavigationService,
        private _frotaService: FrotasService,
        private _frotaApiService: FrotaApiService,
        private _autocompleteService: AutoCompleteService,
        private _frotaNavigationService: FrotaNavigationService,
        private _manutencaoProgramadaService: ManutencaoProgramadaService,
        private _utilService: UtilService
    ) { }

    ngOnInit() {
        this.statusList = this._utilService.cloneObject(OrdemServicoStatus);
        this.statusList.unshift({Key: null, Value: 'Todos'});
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);

        this.testFrotaBackHistory();
    }

    clickNew() {
        this._manutencaoProgramadaService.clearSessionStorage();
        this._ordemServicoService.clearSessionStorage();

        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaManutencaoNew(this.frotaRoute);
        } else {
            this._ordemServicoNavigationService.goToNew();
        }
    }

    clickDetail(item: any) {
        this._ordemServicoService.clearSessionStorage();

        if (this.showFrotaLink) {
            this._frotaNavigationService.goToFrotaManutencaoDetail(this.frotaRoute, item.id);
        } else {
            this._ordemServicoNavigationService.goToDetail(item.id);
        }
    }

    clickDelete(item: OrdemServico) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    changeSearch() {
        this.list = [];
        this.querySearch();
    }

    clickClearSearch() {
        this.startQuery();
        this._autocompleteService.setValueOnSelect2(null, "frota");

        this.changeSearch();
    }

    clickGoToFrotaDetail() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToDetail(this.frotaDetailHistory.id, this.frotaRoute);
    }

    clickGoToFrotaList() {
        this._frotaService.clearBackStorage();
        this._frotaNavigationService.goToList(this.frotaRoute);
    }

    getFrotasObject(object: any) {
        this.query.bem = object;
        this.changeSearch();
    }

    frotaTemplateResult = (function(state: any) {
        let template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    private getQuery(query: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {

                Response.forEach(function(item: any) {
                    item.tipo = this._ordemServicoService.getTipoOrdemServico(item.tipo);
                    item.status = this._ordemServicoService.getStatusOrdemServico(item.status);
                }.bind(this));

                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._ordemServicosApiService.onGetByQuery(query, onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._ordemServicosApiService.onDelete(item.id, onDone);
    }

    private querySearch() {
        this.loading = true;
        let query: any = this._utilService.cloneObject(this.query);
        if (query.status) {
            if (query.status.Key) {
                query.status = query.status.Key;
            } else {
                delete query['status'];
            }
        }

        if (query.bem) {
            query.bemId = query.bem.id;
        }
        delete query['bem'];

        this.getQuery(query);
    }

    private startQuery() {
        this.query.status = this.statusList[1];
        this.query.bem = 0;
    }

    private testFrotaBackHistory() {
        const settings: any = this._frotaService.testBackHistory('frota');

        this.frotaDetailHistory = settings.frotaDetailHistory;
        this.frotasModule = settings.frotasModule;
        this.frotaRoute = settings.frotaRoute;
        this.showFrotaLink = settings.showFrotaLink;

        this.startQuery();
        if (this.showFrotaLink) {
            this.query.bem = this.frotaDetailHistory;
            this.query.status = this.statusList[0];
        }
        this.changeSearch();
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordem-servico-list/ordem-servico-list.component.ts
 **/